// extracted by mini-css-extract-plugin
export var image = "Ksp-module--image--b21d9";
export var ksp = "Ksp-module--ksp--35b11";
export var title = "Ksp-module--title--ec378";